import React, { useEffect } from 'react';
import { useAPI } from "../../../contexts/api";
import useSWR from "swr";
import AppLayout from "../../../components/app/AppLayout";
import moment from 'moment-timezone';

function Index(props) {

  const { getProductUpdates } = useAPI();
  const { data, error } = useSWR(`/productUpdates?fullContent=true`, getProductUpdates);

  useEffect(() => {
    if (data) {
      localStorage.setItem('numUpdates', data.length);
    }
  }, [data]);


  if (!data) return '';

  return (
    <div className="max-w-lg mx-auto flex-col flex justify-center items-center space-y-5">
      {data.map(news => (
        <UpdateItem key={news._id} update={news} />
      ))}
    </div>
  );
}

Index.Layout = AppLayout;
export default Index;


const UpdateItem = ({ update }) => {
  return (
    <div className="border rounded p-5" key={update._id}>
      <div className="newsUpdateItem space-y-4">
        <div className='flex items-center space-x-2 space-x-reverse'>
          <div className="flex items-center">
            {update.type === 'fix' && <span
              className="px-2 py-1 text-xs font-bold leading-none text-white bg-blue-600 rounded-full">תיקון</span>}
            {update.type === 'improvement' && <span
              className="px-2 py-1 text-xs font-bold leading-none text-white bg-indigo-600 rounded-full">שיפור</span>}
            {update.type === 'new' && <span
              className="px-2 py-1 text-xs font-bold leading-none text-white bg-green-600 rounded-full">חדש</span>}
          </div>
          <div className='text-sm text-gray-700'>{moment(update.createdAt).format('DD MMM, YYYY')}</div>
        </div>
        <h1 className="text-lg font-semibold text-gray-900">{update.title}</h1>
        <div className="newsUpdateBody text-sm text-gray-800 leading-relaxed space-y-4"
          dangerouslySetInnerHTML={{ __html: update.content }} />
      </div>
    </div>
  )
}
